import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CentralCatalogueService } from '../../../services/central-catalogue/central-catalogue.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// block or free the selected room-days. only a fully free room-day changes;
// the response names the skipped ones. self-saving.
@Component({
  selector: 'app-cc-block-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent],
  templateUrl: './cc-block-dialog.component.html',
  styleUrls: ['../cc-dialog-form.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CcBlockDialogComponent {
  isLoading: boolean = false;
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<CcBlockDialogComponent>,
    private catalogueService: CentralCatalogueService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: { action: 'BLOCK' | 'UNBLOCK'; instanceIds: number[] }
  ) {}

  get title(): string {
    return this.data.action === 'BLOCK' ? 'Block room-days' : 'Unblock room-days';
  }

  submit(): void {
    if (this.data.action === 'BLOCK' && !this.reason.trim()) {
      this.toastService.error('Give a reason for the block.');
      return;
    }
    this.isLoading = true;
    this.catalogueService
      .blockInstances({
        instanceIds: this.data.instanceIds,
        action: this.data.action,
        reason: this.reason.trim() || null,
      })
      .subscribe({
        next: (res: any) => {
          const skipped = res?.data?.skippedIds?.length || 0;
          if (skipped) this.toastService.error(res?.message || 'Some rows were skipped.');
          else this.toastService.success(res?.message || 'Done.');
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          this.toastService.error(err?.error?.message || 'Failed to update the instances.');
        },
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
